import {createReducer, createAction} from '@reduxjs/toolkit'

interface ThemeModeType {
  mode: 'DEFAULT' | 'CUSTOM' | null
}

const initialState: ThemeModeType = {
  mode: null,
}

export const setCustomTheme = createAction('SET_CUSTOM_THEME')

export const setDefaultTheme = createAction('SET_DEFAULT_THEME')

const themeReducer = createReducer(initialState, builder => {
  builder.addCase(setCustomTheme, state => ({...state, mode: 'CUSTOM'}))
  builder.addCase(setDefaultTheme, state => ({...state, mode: 'DEFAULT'}))
})

export default themeReducer
